import React, { useEffect, useState } from 'react';
import EditableTaskFieldView from '../view/EditableTaskFieldView';
import getUTCNoonForDate from '../../../utils/getUTCNoonForDate';

const EditableTaskFieldEngine = ({
  fieldId,
  value,
  uiType,
  initialDisplayValue = '',
  isEditable,
  isEditing = false,
  required,
  setValue = () => {},
  setIsEditing = () => {}
}) => {
  const [showingValue, setShowingValue] = useState(
    initialDisplayValue ? initialDisplayValue : value
  );
  const [valueToSave, setValueToSave] = useState(value);
  const onChange = v => {
    let newShowingValue = v,
      newSavingValue = v;
    if (uiType === 'date') {
      newShowingValue = v ? getUTCNoonForDate(v) : null;
      newSavingValue = newShowingValue;
    }
    if (uiType === 'user') {
      newShowingValue = v.label.replace('<', '\n').replace('>', '');
      newSavingValue = v.value;
    }
    if (
      uiType === 'priority' ||
      uiType === 'status' ||
      uiType === 'long_text' ||
      uiType === 'text'
    ) {
      newShowingValue = v.target.value;
      newSavingValue = v.target.value;
    }
    setShowingValue(newShowingValue);
    setValueToSave(newSavingValue);
  };
  const onCancelEdit = () => {
    setIsEditing(false);
    setShowingValue(initialDisplayValue ? initialDisplayValue : value);
  };
  const onConfirmEdit = () => {
    if (required && !valueToSave) {
      return;
    }
    setValue(valueToSave);
    setIsEditing(false);
  };
  const viewProps = {
    fieldId,
    isEditable,
    isEditing,
    onCancelEdit,
    onConfirmEdit,
    onChange,
    required,
    setIsEditing,
    showingValue,
    uiType,
    value
  };

  return <EditableTaskFieldView {...viewProps} />;
};

export default EditableTaskFieldEngine;
